<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
		
      <div class="dlblock-mb20 mr10">
        <span class="pr5">姓名</span>
        <el-input v-model.trim="name" placeholder="请输入姓名" style="width: 150px;"/>
      </div>

     <div class="dlblock-mb20 mr10">
        <span class="pr5">手机号</span>
        <el-input v-model.trim="phone" placeholder="请输入手机号" style="width: 150px;"/>
      </div>

	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">客户类型</span>
	    <el-select v-model="typePsStatus" class="w150" clearable>
	      <el-option v-for="(item, index) in typePsList" :key="item.value" :label="item.key"
	                 :value="item.value"/>
	    </el-select>
	  </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">场地</span>
	    <el-select v-model="fieldPsStatus" class="w150" clearable>
	      <el-option v-for="(item, index) in fieldPsList" :key="item.value" :label="item.key"
	                 :value="item.value"/>
	    </el-select>
	  </div>
	  
    <!--  <div class="dlblock-mb20 mr10">
        <span class="pr5">批次号</span>
        <el-input v-model.trim="batch" placeholder="请输入批次号" style="width: 150px;"/>
      </div> -->
	  

	   <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
			class="reset-clear"
			:clearable="false"
			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始日期"
	        />
	  </div> 
	  

	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
          v-model="updateTime"
		  style="width: 180px;"
          type="datetime"
          :clearable="false"
          unlink-panels
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
           />
	  </div> 

      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; ydGetMerchantWhiteListPageFn()">
          搜索
        </el-button>
      </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(3)">
	      白名单excel模版下载
	    </el-button>
	  </div>
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="editBtn(1)">
          白名单excel上传
        </el-button>
      </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(2)">
	      白名单用户与商户建立关系
	    </el-button>
	  </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(6)">
	      新增
	    </el-button>
	  </div>

    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="id" label="编号"></el-table-column>
	  <el-table-column align="center" prop="name" label="名称"></el-table-column>
	  <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
	  <el-table-column align="center" prop="typeStr" label="类型"></el-table-column> 
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
     
      <el-table-column align="center" width="150" label="操作">
        <template slot-scope="{row}">
			<!-- TODO 写一哈 -->
          <a class="glob-a"  @click="editBtn(4, row)">修改</a>
        <!--  <a class="glob-a"  @click="auditShow = {modal: true, data: row}">查看</a>
		  <a class="glob-a"  @click="editBtn(5, row)">删除</a> -->
        </template>
      </el-table-column> 
	 
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <el-dialog :title="editData.add === 1 ? '白名单Excel上传' : '编辑'" :visible.sync="editData.modal" width="500px">
      <el-form label-width="150px">
        <el-form-item label="文件：">
			<el-row>
			  <word-img class="mr10 mb10" v-model="editData.picture" :balance="balance" :total="1"/>
			</el-row>
        </el-form-item>
      </el-form>
    </el-dialog>
	
	
	<!-- 详情 -->
	<el-dialog :title="detailName" :visible.sync="detailModal" fullscreen>
	  <detail :id="detailId"/>
	</el-dialog>
	
	
	
	<!-- 新增编辑 -->
	  <el-dialog :title="editDataUp.add === 1 ? '新增白名单用户' : '编辑白名单用户'" :visible.sync="editDataUp.modal" width="400px">
	    <el-form label-width="120px">
			<el-form-item label="名称：">
			   <el-input v-model.trim="editDataUp.name" placeholder="请输入名称"/>
			</el-form-item>
			
			<el-form-item label="手机号：">
			   <el-input v-model.trim="editDataUp.phone" placeholder="请输入手机号"/>
			</el-form-item>
			
			<!-- <el-form-item label="客户类型：">
			   <el-input v-model.trim="editDataUp.type" placeholder="请输入型号"/>
			</el-form-item> -->
			
			<el-form-item label="类型：">
				<el-select v-model="editDataUp.type" class="w150" >
				  <el-option v-for=" item in subMerTypeList " 
				  :key="item.value" :label="item.name" :value="item.value"/>
				</el-select>
			</el-form-item>
			
	    </el-form>
	
	    <div slot="footer">
	      <el-button @click="editDataUp.modal = false">取 消</el-button>
	      <el-button type="primary" @click="ydSnhMerchantWhiteListSaveOrUpdateFn">确 定</el-button>
	    </div>
	  </el-dialog>
	  
  </div>
</template>

<script>
  import Detail from './Detail.vue'
	
  import {
    ydGetMerchantWhiteListPage,
	
    addOrEditWordform,
	getEnwordMarkDelete,
	getEnWordInspect,
	
	//白名单新增或修改
	ydSnhMerchantWhiteListSaveOrUpdate
	
  } from '@/api'
  
  import {
	  //综合商户白名单模版下载
	  getSnhMerchantWhiteListDownload } from '@/api/indexUtil'

   import WordImg from '@/components/snhWhitelistFile.vue'

  export default {
    name: 'whiteList',
    components: {Detail,WordImg},
    data () {
      return {
        balance:10,
        name:'',
        phone:'',
        batch:'',
        createTime:'',
		updateTime:'',
		word:'',
		chinese:'',
        date: '',
        tableData: [],
        tableLoading: false,

        auditShow: {
          modal: false,
          data: {}
        },
		//白名单excel上传
        editData: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
		//新增或修改白名单
		editDataUp:{
			modal: false,
			add: 1,
			id:'',
			name:'',
			phone:'',
			type:''
		},
		//白名单用户类型
		subMerTypeList:[{name:"白名单用户",value:0},{name:"代发客户",value:1},{name:"三代社保卡",value:2}],

     //银行食堂上传人脸识别日志一楼
		faceRecognitionLog: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
        typeList: [],
        pages: {
          page: 1,
          total: 0
        },
		// 详情
		detailId: '',
		detailModal: false,
		//包名
		detailName:'',
		//用户类型
		 typePsList: [{key:"请选择",value:""},
		 {key:"白名单用户",value:"0"},
		 {key:"三代社保卡",value:"2"},
		 {key:"代发客户",value:"1"}
		 ],
		//客户类型
		typePsStatus:'',
		//场地
		fieldPsList: [{key:"请选择",value:""},
		 {key:"安徽广播电视台",value:"0"},
		 {key:"祁门路联通大厦",value:"1"},
		 {key:"银监局",value:"2"}
		 ],
		//场地
		 fieldPsStatus:''
      }
    },
     watch: {
            // 如果 `question` 发生改变，这个函数就会运行
            balance: function () {               
                
            }
        },
    created () {
      this.ydGetMerchantWhiteListPageFn()
    },
    methods: {
      ydGetMerchantWhiteListPageFn(){
        this.tableLoading = true
        ydGetMerchantWhiteListPage({
          pageNum: this.pages.page,
          createTime: this.createTime,
          updateTime: this.updateTime,
          name: this.name,
          phone: this.phone,
          batch:this.batch,
		  type:this.typePsStatus,
		  field:this.fieldPsStatus
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
	  //白名单新增或修改
	  ydSnhMerchantWhiteListSaveOrUpdateFn(){
	    this.tableLoading = true
	    ydSnhMerchantWhiteListSaveOrUpdate({
	      id: this.editDataUp.id,
	      name: this.editDataUp.name,
	      phone: this.editDataUp.phone,
	      type: this.editDataUp.type
	    }).then(res => {
	      if(res.code == 200){
			  this.editDataUp = { modal:false }
		  }else{
			  this.$message.success(res.msg)
		  }
	    }).finally(() => {
	      this.tableLoading = false
	    })
	  },
	  getEnwordMarkDeleteFn(id) {
	    this.tableLoading = true
	    getEnwordMarkDelete(id).then(res => {
	     this.$message.success(res.msg)
	     this.ydGetMerchantWhiteListPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
	  editBtn(t,row) {
		  //1白名单excel上传 2白名单用户与商户建立关系 3白名单excel模版下载 4修改 5删除 6新增白名单
		  if(t == 1){
			 this.editData = {
			   modal: true,
			   userId: '',
			   add: 1
			 }
		  }else if(t == 2){
			//白名单用户与商户建立关系
			this.detailModal = true
			this.detailId = 1 //row.id
			 //包名
			 this.detailName = "白名单用户与商户建立关系" //row.name
		  }else if(t == 3) {
			  getSnhMerchantWhiteListDownload()
			  .then(res => {
				this.downloadFile(res)
			    this.editData.modal = false
			    this.$message.success(res.data)
			  })
			  console.info("白名单excel模版下载")
	      }else if(t == 4) {
			//修改白名单列表item	
			this.editDataUp = {
	   			   modal: true,
	   			   add: 2,
				   id:row.id,
	   			   name: row.name,
	   			   phone: row.phone,
	   			   type: row.type
	   			  }
	    }else if(t == 5){
			this.$confirm(`确认要删除吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
				 let id =  row.id
			     this.getEnwordMarkDeleteFn(id);
			});	
		}else if(t ==6){
			//修改白名单列表item
			this.editDataUp = { modal: true }
		}
	},
	// 文件下载导出
	  downloadFile(res) {
	  let url = window.URL.createObjectURL(new Blob([res.data]));
	  let link = document.createElement('a');
	  link.style.display = 'none';
	  link.href = url;
	  link.setAttribute('download', '白名单模版.xls');
	  document.body.appendChild(link);
	  link.click()
	},
      pageChange (val) {
        this.pages.page = val
        this.ydGetMerchantWhiteListPageFn()
      }
    }
  }
</script>

<style scoped>
  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
